import axios from '@/axios/api.request'

export const save = (from) => axios.request({
  url: '/trademark/save',
  data: from,
  method: 'post'
})

export const decp = (from) => axios.request({
  url: '/trademark/decp',
  data: from,
  method: 'post'
})

export const edit = (from) => axios.request({
  url: '/trademark/edit',
  data: from,
  method: 'post'
})